import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { getCMSHomepageGrid } from '@/api/cms';
import { getOrFetchHeaderData } from '@/utils/headerCalls';
import { getOrFetchConfiguration } from '@/utils/getConfiguration';
import { getLayoutProps } from '@/utils/layout/layout';
import AccounteDetailsPage from '@/components/AccountDetailsPage/AccountDetailsPage';
import User from '@/store/user';
import LoginLayout from '@/components/LoginLayout/LoginLayout';
import { useTranslations } from 'next-intl';

export default function Login({ logo, loginLogo, loginConfig, loginImage, responsiveLogo }) {
  const t = useTranslations('account_details');
  const [config, setConfig] = useState();
  const [user, setUser] = useState();
  loginImage === '' ? (loginConfig = 0) : null;
  const [radioButtonList, setRadioButtonList] = useState([
    {
      label: t('radio_new_card'),
      disabled: false,
      selected: true,
      id: '0',
    },
    {
      label: t('radio_existing_card', { loyaltyName: process.env.loyaltyName }),
      disabled: false,
      selected: false,
      id: '1',
    },
  ]);
  const router = useRouter();
  useEffect(() => {
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
      let tempRadioList = [...radioButtonList];
      // if(config.loyalty.cardSetOptions)
      configuration?.loyalty?.cardSetOptions?.map(item => {
        if (item === 'SKIP') {
          tempRadioList.push({
            label: t('radio_skip'),
            disabled: false,
            selected: false,
            id: '2',
          });
          setRadioButtonList(tempRadioList);
        }
      });
      return;
    }

    getConfiguration();
  }, []);

  useEffect(() => {
    const user$ = User.subscribe(_user => {
      setUser(_user);
      if (!_user?._id) {
        router.replace('/');
        return;
      }
    });

    return () => user$.unsubscribe();
  }, []);

  if (!user?._id) return null;
  return (
    <>
      <LoginLayout type={loginConfig} image={loginImage} responsiveLogo={responsiveLogo}>
        {config && (
          <AccounteDetailsPage
            config={config}
            radioButtonList={radioButtonList}
            setRadioButtonList={setRadioButtonList}
            logo={loginLogo ? loginLogo : logo}
            type={loginConfig}
          />
        )}
      </LoginLayout>
    </>
  );
}

export async function getStaticProps({ locale }) {
  const { responsiveLogo } = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, locale);
  const [{ data: logoData }, { data: loginLogoData }, { data: loginAllData }] = await Promise.all([
    getCMSHomepageGrid('header_logo', locale),
    getOrFetchHeaderData('login_logo', locale),
    getOrFetchHeaderData('login_page', locale),
  ]);
  const logo = logoData.data[0].content.logo.url;
  const loginLogo = loginLogoData.data[0].content.login_logo.url;
  const loginConfig = loginAllData.data[0].content.configuration;
  const loginImage = loginAllData.data[0].content.image?.url ? loginAllData.data[0].content.image?.url : '';

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${locale}/common.json`)).default,
    account_details: (await import(`../../../prebuild-data/i18n/${locale}/account_details.json`)).default,
    user_credentials: (await import(`../../../prebuild-data/i18n/${locale}/user_credentials.json`)).default,
  };

  return {
    props: {
      responsiveLogo,
      logo,
      loginLogo,
      loginConfig,
      loginImage,
      messages,
    },
  };
}
